import { render, staticRenderFns } from "./PortDashboard.vue?vue&type=template&id=58d627a8&scoped=true&"
import script from "./PortDashboard.vue?vue&type=script&lang=js&"
export * from "./PortDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PortDashboard.vue?vue&type=style&index=0&id=58d627a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d627a8",
  null
  
)

export default component.exports